var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6049",
    d: "m600 1200c-159.13 0-311.74-63.215-424.27-175.73-112.52-112.52-175.73-265.14-175.73-424.27s63.215-311.74 175.73-424.27c112.52-112.52 265.14-175.73 424.27-175.73s311.74 63.215 424.27 175.73c112.52 112.52 175.73 265.14 175.73 424.27-0.19141 159.07-63.465 311.57-175.95 424.05-112.48 112.48-264.98 175.75-424.05 175.95zm0-1128c-140.04 0-274.33 55.629-373.35 154.65-99.02 99.02-154.65 233.32-154.65 373.35s55.629 274.33 154.65 373.35c99.02 99.02 233.32 154.65 373.35 154.65s274.33-55.629 373.35-154.65c99.02-99.02 154.65-233.32 154.65-373.35-0.16016-139.98-55.84-274.19-154.82-373.18s-233.19-154.66-373.18-154.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6049",
    d: "m631.8 786.36-186.48-186.48 186.48-186.24 50.879 50.879-135.48 135.36 135.48 135.6z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back_arrow.1f29b7ff318bed94781e1a831e45bd96.svg";